/**
 * Constantes de rotas da aplicação
 * Organizadas por categoria funcional para melhor manutenção
 */
export const ROUTES = {
	// Rotas públicas - não requerem autenticação
	PUBLIC: {
		LOGIN: '/login',
		FORCE_CHANGE_PASSWORD: '/force-change-password',
		RECOVER_PASSWORD: '/recover-password',
	},

	// Rotas privadas - Dashboard
	DASHBOARD: {
		HOME: '/',
		PROFILE: '/profile',
		VIRTUAL_BADGE: '/cracha',
		NOTICES: '/notices',
		NOTICE_DETAIL: '/notices/:id',
		CAMPAIGNS: '/campaigns',
		CAMPAIGN_DETAIL: '/campaigns/:id',
		MY_COMMITMENT_EXCEPTIONS: '/my-commitment-exceptions',
		COMMITMENT_MATRIX_DASHBOARD: '/commitment-matrix-dashboard',
	},

	// Rotas de Inspeções
	INSPECTIONS: {
		INDEX: '/inspections',
		DIRECTED: {
			INDEX: '/inspections/directed',
			NEW: '/inspections/directed/new',
		},
		SEE_AND_ACT: {
			INDEX: '/inspections/see-and-act',
			NEW: '/inspections/see-and-act/new',
		},
		YELLOW_CARD: {
			INDEX: '/inspections/yellow-card',
			NEW: '/inspections/yellow-card/new',
			DETAIL: '/inspections/yellow-card/:id',
		},
		INTERACTION: {
			INDEX: '/inspections/interaction',
			ACTIONS_IN_PROGRESS: '/inspections/actions-in-progress',
			NEW: '/inspections/interaction/new',
		},
		ACTIONS_IN_PROGRESS: '/inspections/actions-in-progress',
	},

	// Rotas de Ocorrências (protótipo com dados mock)
	OCCURRENCES: {
		INDEX: '/occurrences',
		NEW: '/occurrences/new',
		DETAIL: '/occurrences/:id',
	},

	// Rotas de DDS (Diálogo Diário de Segurança)
	DDS: {
		INDEX: '/dds',
		NEW: '/dds/new',
		DETAIL: '/dds/:id',
		HUB: '/dds/menu',
		CHECK_IN: '/dds/presenca',
		ATTENDANCE: '/dds/:id/lista',
		EMOTIONS: '/dds/emociograma',
	},

	// Rotas de Administração SSMA
	ADMINISTRATION: {
		INDEX: '/administration',
		GROUP: '/administration/menu/:group',
		WHATS_NEW: '/administration/whats-new',
		QUESTIONNAIRES: '/administration/questionnaires',
		QUESTIONNAIRES_FORM: '/administration/questionnaires/form',
		BRANCHES_CONTRACTS: '/administration/branches-contracts',
		BRANCHES_CONTRACTS_FORM: '/administration/branches-contracts/form',
		BADGES: '/administration/badges',
		NOTIFICATIONS: '/administration/notifications',
		NOTIFICATIONS_FORM: '/administration/notifications/form',
		CAMPAIGNS: '/administration/campaigns',
		CAMPAIGNS_FORM: '/administration/campaigns/form',
		CAMPAIGN_RESULTS: '/administration/campaigns/:id/results',
		TYPOLOGY_RISKS: '/administration/typology-risks',
		TYPOLOGY_RISKS_FORM: '/administration/typology-risks/form',
		CLASSIFICATIONS: '/administration/classifications',
		CLASSIFICATIONS_FORM: '/administration/classifications/form',
		UPLOAD_EMPLOYEES: '/administration/upload-employees',
		SYNC_PROTHEUS: '/administration/sync-protheus',
		FIX_INSPECTION: '/administration/fix-inspection',
		FIX_INSPECTION_FORM: '/administration/fix-inspection/form',
		USERS: '/administration/users',
		CONTRACTS: '/administration/contracts',
		CUSTOMERS: '/administration/customers',
		DDS_MONTHLY_THEMES: '/administration/dds-monthly-themes',
		CUSTOMER_CLASSIFICATIONS: '/administration/customer-classifications',
		ORG_OVERRIDES: '/administration/org-overrides',
		SPHERA_EXPORT: '/administration/sphera-export',
		SPHERA_OPTIONS: '/administration/sphera-options',
		COMMITMENT_MATRIX: '/administration/commitment-matrix',
		SCORING: '/administration/scoring',
		KPI_METRICS: '/administration/kpi-metrics',
		KPI_METRICS_TAB: '/administration/kpi-metrics/:tab',
	},
} as const

/**
 * Tipos de rotas para TypeScript
 */
export type RoutePath = typeof ROUTES

export type PublicRoutes = RoutePath['PUBLIC'][keyof RoutePath['PUBLIC']]

export type PrivateRoutes = RoutePath['DASHBOARD'][keyof RoutePath['DASHBOARD']]

export type AppRoutes = PublicRoutes | PrivateRoutes

/**
 * Utilitários para trabalhar com rotas
 */
export const RouteUtils = {
	isPublicRoute: (path: string): boolean => {
		return Object.values(ROUTES.PUBLIC).includes(path as PublicRoutes)
	},

	isPrivateRoute: (path: string): boolean => {
		return Object.values(ROUTES.DASHBOARD).includes(path as PrivateRoutes)
	},
} as const
